import { defineMessages } from 'react-intl';

export default defineMessages({
  returnToHomepage: 'Return to Homepage'
});

